export const PageNotFound = () => {
  return (
    <b className={"m-5 h-2rem"}>La page que vous cherchez n'existe pas !</b>
  );
};
